import { VerifyPhoneNumberDialog } from "./VerifyPhoneNumberDialog";
import { useVerifyPhoneNumber } from "../hooks/useVerifyPhoneNumber";

export function VerifyPhoneNumberEntry() {
  const { 
    open, 
    setOpen,
    step,
    phoneNumber,
    handlePhoneChange,
    isLoading,
    errorMessage,
    successMessage,
    sendOtp,
    resendOtp,
    verifyOtp,
    goBackToPhone,
    handleLogout,
  } = useVerifyPhoneNumber();

  if (!open) return null;

  return (
    <VerifyPhoneNumberDialog
      open={open}
      onOpenChange={setOpen}
      step={step}
      phoneNumber={phoneNumber}
      handlePhoneChange={handlePhoneChange}
      isLoading={isLoading}
      errorMessage={errorMessage}
      successMessage={successMessage}
      sendOtp={sendOtp}
      resendOtp={resendOtp}
      verifyOtp={verifyOtp}
      goBackToPhone={goBackToPhone}
      handleLogout={handleLogout}
    />
  );
}